import React from "react";
import { ArrowRightIcon, LockIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CtaButtonProps = {
  label: string;
  id?: string;
  microcopy?: string;
  tone?: "dark" | "light";
};
export function CtaButton({
  label,
  id,
  microcopy,
  tone = "dark"
}: CtaButtonProps) {
  return <div id={id} className="mx-auto flex w-full max-w-xl flex-col items-center" data-id="element-27" data-mp="cjr9i0yr21ss">
      <a href={CHECKOUT_URL} className="cta-pulse group flex w-full items-center justify-center gap-3 rounded-2xl border-b-4 border-cta-hover bg-cta px-5 py-5 text-center font-display text-[15px] font-extrabold uppercase leading-tight tracking-wide text-cta-text transition-[transform,background-color] duration-150 ease-out hover:bg-[#2DD46A] active:translate-y-0.5 sm:text-lg" data-id="element-28" data-mp="qk20d4027gdy">
        <span data-id="element-29" data-mp="19aa0recdjsqg">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-30" data-mp="19busyxb7uzl5" />
      </a>
      {microcopy && <p className={`mt-3 flex items-center justify-center gap-1.5 text-center text-xs font-medium sm:text-sm ${tone === "dark" ? "text-slate-300" : "text-slate-600"}`} data-id="element-31" data-mp="35xxukwcpwzvx">
          <LockIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-32" data-mp="3ey41u0htp3mn" />
          {microcopy}
        </p>}
    </div>;
}